// extracted by mini-css-extract-plugin
export default {"button":"menu_button__khgnd","buttonContent":"menu_buttonContent__hEGMW","overlay":"menu_overlay__j7+cB","am-fade-in":"menu_am-fade-in__PIMJ2"};